import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nimbus-form-row',
  templateUrl: './form-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormRowComponent {
  @HostBinding('class')
  public class: string = 'nimbus-form-row';
}
